<script setup lang="ts">
const { t } = useEkI18n();
const settingsStore = useSettingsStore();

async function updateConvertHeicPreference(value: boolean) {
  await settingsStore.set('convertHeic', value);
}
</script>

<template>
  <SettingsToggle
    :checked="settingsStore.settings.convertHeic"
    :label="t('settings.documents.convertHeic')"
    :description="t('settings.documents.convertHeicDescription')"
    @change="updateConvertHeicPreference"
  />
</template>
